import React from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Modal } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { setIsOpenCalendarModal } from '../../redux/mainReducer';

import './DeleteModal.css';
import { DateCalendar } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: { xs: 390, sm: 710, md: 820, lg: 900, xl: 900 },
  minWidth: 390,

  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function CalendarModal({ isOpenModal, func, id, startDate }) {
  const dispatch = useDispatch();
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(
            setIsOpenCalendarModal({ isOpen: false, func: null, id: null, startDate: null })
          );
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_delete_modal"
      >
        <Box sx={style} className="bonfair_delete_modal-box">
          <CloseIcon
            className="bonfair_delete_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(
                setIsOpenCalendarModal({ isOpen: false, func: null, id: null, startDate: null })
              );
            }}
          />
          <DateCalendar
            onChange={(newValue) => {
              const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
              const today = dayjs().format('YYYY-MM-DD');

              if (selectedDate === startDate) return;
              if (dayjs(selectedDate).isBefore(today)) return;

              func(selectedDate, id, startDate);
              dispatch(
                setIsOpenCalendarModal({ isOpen: false, func: null, id: null, startDate: null })
              );
            }}
          />
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(CalendarModal);
